<template>
  <SidebarSection
    v-if="isShow"
    width="60%"
    :disabledAction="true"
    title="ar_client_detail_travelagent"
    :isShow.sync="isShow"
  >
    <div class="mt-1">
      <b-row class="m-0 mb-1">
        <b-col md="6">
          <h6 class="content-title">
            {{ $t("ar_voucher_general_information") }}
          </h6>
        </b-col>
      </b-row>
      <GeneralInfo leftWidth="100px" rightWidth="90px" :list="listGeneral" />
    </div>
    <!-- <div class="divider"></div>
    <h6 class="mb-2 mt-1 ml-1">
      {{ $t("ar_client_list_debit_account") }}
    </h6>
    <div class="px-1">
      <TableAccount :columns="columns" :data="data" />
    </div>
    <div class="divider"></div> -->
  </SidebarSection>
</template>
<style lang="scss" scoped>
::v-deep .detail-sidebar {
  label {
    display: inline-block;
  }
  label.left-width {
    width: 100px;
  }
  label.right-width {
    width: 70px;
  }
}

@import "./SidebarClient.scss";
</style>
<script >
import ModalAccount from "../ModalAccount/ModalAccount.vue";
import TableAccount from "../../ListAccount/components/TableAccount.vue";
import GeneralInfo from "../../ultils/General/GeneralInfo.vue";
import SidebarSection from "../../ultils/Sidebar/SidebarSection.vue";

import { defineComponent, ref, computed, getCurrentInstance } from "@vue/composition-api";

export default defineComponent({
  name: "SidebarClient",
  components: {
    SidebarSection,
    GeneralInfo,
    TableAccount,
    ModalAccount,
  },
  props: {
    isShow: Boolean,
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  setup(props) {
    const listGeneral = computed(() => [
      {
        icon: "briefcase",
        label: "ar_client_agency",
        content: `${props.data.NameVi} (${props.data.TravelAgentCode}) `,
      },

      {
        icon: "phone",
        label: "ar_common_phone",
        content: `${props.data.Tel1} - ${props.data.Tel2} `,
      },
      {
        icon: "code",
        label: "ar_common_tax_code",
        content: props.data.TaxCode,
      },
      {
        icon: "code",
        label: "ar_common_zipcode",
        content: props.data.ZipCode,
      },
      {
        icon: "place",
        label: "ar_common_address",
        content: props.data.Address1,
      },
      {
        icon: "place",
        label: "ar_client_district",
        content: props.data.StateVi,
      },
      {
        icon: "place",
        label: "ar_common_city",
        content: props.data.CityVi,
      },
      {
        icon: "place",
        label: "ar_common_country",
        content: props.data.CountryVi,
      },
      {
        icon: "note",
        label: "ar_client_description",
        content: props.data.DescriptionVi,
      },
    ]);
    const columns = ref([
      {
        caption: "ar_client_debit_account_code",
        field: "AccountCode",
        width: "15%",
      },
      {
        caption: "ar_client_site_code",
        field: "PropertyName",
      },
      {
        caption: "ar_client_account_credit_balances",
        field: "CreditBalance",
        formatType: "currency",
        cellTemplate: true,
        isShow: true,
        width: "15%",
      },
      {
          caption: "ar_client_amount_held",
          field: "HoldBalance",
          cellTemplate: true,
          formatType: "currency",
          width:"15%"
        },
      {
        caption: "ar_client_account_debit_balances",
        field: "DebitBalance",
        formatType: "currency",
        cellTemplate: true,
        width: "15%",
      },
    ]);

    return { columns, listGeneral };
  },
});
</script>
